import { PageFilter } from "../../shared/components/filter";
import { PageHeading } from "../../shared/components/heading";
import request from "../../shared/utils/request";
import { useEffect, useState } from "react";
import { formatDate } from "../../shared/utils/dateFormat";
import "../myLibrary/style.css";
import { Link } from "react-router-dom";
import { Loader } from "../../shared/components/loader";
import "../myAnswers/style.css";
import { Slide } from "react-awesome-reveal";

export const Feedbacks = () => {
  const [loading, setLoading] = useState(false);
  const [cardDatas, setCardDatas] = useState([]);

  useEffect(() => {
    getDatas();
  }, []);

  const getDatas = async () => {
    try {
      setLoading(true);
      const response = await request.get("student/getEvaluatedAnswers");
      if (response?.data?.success) {
        setCardDatas(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching  data:", error);
    } finally {
      setLoading(false); // Step 3: Set loading to false after the request is completed
    }
  };

  return (
    <section id="services" className="services section my-library">
      <div className="container section-title" data-aos="fade-up">
        <Slide direction="down">
          <PageHeading heading={"Answer Feedbacks"} />
        </Slide>
      </div>
      <Loader isLoading={loading} />
      <div className="container my-answers-date-card">
        <div className="row justify-content-left">
          {cardDatas?.map((cardData, rowIndex) => (
            <div className="col-md-3 mt-4 mb-4" key={rowIndex}>
              <Link
                to={`/student/feedback-questions/${cardData?.evaluated_date}`}
              >
                <div className="counter-card card theme-emerald shadow-sm rounded-4">
                  <div className="card-body p-4">
                    <div className="date-display mb-3">
                      {formatDate(cardData?.evaluated_date)}
                    </div>
                    <div className="row">
                      {/* <div className="col-md-6">
                        <h6 className="card-title">
                          <i className="fas fa-users" />
                          Pending
                        </h6>
                        <span className="counter-badge">{cardData?.count}</span>
                      </div> */}
                      {/* <div className="col-md-6">
                        <h6 className="card-title text-danger">
                          <i className="fas fa-users" />
                          Pending
                        </h6>
                        <span className="counter-badge-red">
                          {cardData?.count}
                        </span>
                      </div> */}
                      <div className="col-md-6">
                        <h6 className="card-title">
                          <i className="fas fa-users" />
                          Reviewed
                        </h6>
                        <span className="counter-badge">{cardData?.count}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
